<div class="container mt-5">
    <div class="row mt-5">
        <div class="col-md-4 offset-md-4 col-sm-6 offset-sm-3 text-center mt-5">
            <p class="h3 mb-4">
                CMS Administration
            </p>
            <p class="text-muted textBody--md u-marginTop--reset u-marginBottom--large">You have been signed out of the CMS portal.</p>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12 text-center">
            <small>Need assistance? | <a href="mailto:gtls@deloitte.com?subject=General Enquiry">Contact us</a></small>
        </div>
    </div>
</div>